import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

/** 拉取共享 PVC 列表（与 cloud-host service 一致） */
export function getPersistentVolumeClaims(params: Record<string, unknown> = {}) {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.persistentvolumeclaim)}/all-persistentvolumeclaims`, {
    limit: -1,
    type: 'shared',
    ...params,
  });
}
